import React, { Fragment, useState } from 'react';
import RecordsTable from './recordsTable';
import { useFetch } from '../../../lib/useFetch';
import PaginationBar from '../../../components/pagination';
import { useParams } from 'react-router-dom';

const citiesHeaders = ["photo", "name", "code"];

const mapResponseData = (data) => {
  debugger
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['flag'] = obj['photo'];
    trimmedObj['name'] = obj['name'];
    trimmedObj['code'] = obj['cityCode'];
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Cities = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)
  const {id} = useParams()

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`cities?countryId=${id}&page=${page}${searchParam}`, reload);

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={citiesHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={() => toggleReload(r => !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />
      <PaginationBar page={page} totalCount={totalCount} setPage={setPage} />
    </Fragment>
  );
}

export default Cities;